<div class="checkout-upsell-timer" [formGroup]="timerForm">
  <div class="content">
    <pdq-card variant="popover" color="white">
      <div class="card-title">
        <pdq-heading element="h5">Enable Countdown Timer</pdq-heading>
        <pdq-slide-toggle formControlName="enableCountdownTimer"></pdq-slide-toggle>
      </div>
      <div class="card-container">
        <span>Add Urgency With A Countdown In Your Upsell Messages</span>
      </div>
    </pdq-card>

    <pdq-card variant="popover" color="white">
      <div class="card-title">
        <pdq-heading element="h5">Configure</pdq-heading>
      </div>
      <pdq-divider></pdq-divider>
      <div class="card-container">
        <pdq-heading element="h6">Timer Duration</pdq-heading>
        <div class="timer-duration-row">
          <pdq-input-arrows
            widthSize="fullwidth"
            min="1"
            max="60"
            formControlName="timerDuration"
            placeholder="5"></pdq-input-arrows>
          <pdq-dropdown
            (onChange)="onTimerUnitChange($event)"
            [options]="timerUnitOptions"
            [dirty]="false"
            [defaultOption]="timerForm.get('timerUnit')?.value | primitiveDropdownOptionPipe"></pdq-dropdown>
        </div>
        <span class="timer-info-text">Timer starts when customer reaches checkout</span>

        <pdq-heading element="h6">Time Format</pdq-heading>
        <pdq-radio-group formControlName="timeFormat" label="">
          <pdq-radio-button
            [value]="TIME_FORMATS.DIGITAL"
            text="Digital (01:30:45)"
            [checked]="timerForm.get('timeFormat')?.value === TIME_FORMATS.DIGITAL"></pdq-radio-button>
          <pdq-radio-button
            [value]="TIME_FORMATS.COMPACT"
            text="Compact (1Hr 30m)"
            [checked]="timerForm.get('timeFormat')?.value === TIME_FORMATS.COMPACT"></pdq-radio-button>
        </pdq-radio-group>

        <pdq-heading element="h6">Placement</pdq-heading>
        <pdq-radio-group formControlName="placement" label="" [preserveTextCase]="true">
          <pdq-radio-button
            [value]="TIMER_PLACEMENTS.INLINE_BAR"
            text="Inline Bar"
            [checked]="timerForm.get('placement')?.value === TIMER_PLACEMENTS.INLINE_BAR"></pdq-radio-button>
          <pdq-radio-button
            [value]="TIMER_PLACEMENTS.BADGE"
            text="Badge"
            [checked]="timerForm.get('placement')?.value === TIMER_PLACEMENTS.BADGE"></pdq-radio-button>
          <pdq-radio-button
            [value]="TIMER_PLACEMENTS.IN_GOAL_MESSAGE"
            text="In Goal Message"
            [checked]="timerForm.get('placement')?.value === TIMER_PLACEMENTS.IN_GOAL_MESSAGE"></pdq-radio-button>
        </pdq-radio-group>

        @if (timerForm.get('placement')?.value === TIMER_PLACEMENTS.IN_GOAL_MESSAGE) {
          <pdq-banner variant="attention" [closable]="false">
            <p class="banner-text">
              Add the &#123;countdown&#125; token to your goal message to display the timer inline with your text. Edit
              your messages in the
              <span class="goals-tab-link" (click)="navigateToGoalsTab.emit()">Goals tab</span>.
            </p>
          </pdq-banner>
        }

        @if (timerForm.get('placement')?.value !== TIMER_PLACEMENTS.IN_GOAL_MESSAGE) {
          <pdq-heading element="h6">Messages</pdq-heading>
          <div class="messages-subtitle-wrapper">
            <span class="messages-subtitle">Default Message Displayed</span>
            <pdq-button
              class="eye-preview-button"
              variant="empty"
              [icon]="timerPreviewMode === TIMER_STATES.DEFAULT ? 'preview_eye' : 'preview_eye_crossed'"
              [iconColor]="
                timerPreviewMode === TIMER_STATES.DEFAULT ? 'var(--on-surface-default)' : 'var(--on-surface-light)'
              "
              (click)="setTimerPreviewMode(TIMER_STATES.DEFAULT)">
            </pdq-button>
          </div>
          <rich-text-editor
            [control]="timerForm.get('defaultMessage')"
            placeholder="Only {countdown} left to claim this offer!"
            [config]="{
              items: timerDynamicFieldsOptions$ | async,
              triggerChar: '{',
              filterByKey: 'searchTerm',
              removeTriggerCharOnSelect: true,
              descriptionKey: 'description',
              variant: 'categorizedOptions',
            }"></rich-text-editor>
          <p class="timer-info-text">
            Dynamic fields available. Type &#123; to see options.<br />Ex: Use &#123;countdown&#125; to dynamically
            display the time remaining
          </p>

          <div class="field-group">
            <pdq-dropdown
              formControlName="backgroundColor"
              [options]="bannerVariantOptions"
              [fullWidth]="true"
              [title]="'Default style'"></pdq-dropdown>
          </div>

          <div class="messages-subtitle-wrapper">
            <span class="messages-subtitle">Message When Timer Is Low</span>
            <pdq-button
              class="eye-preview-button"
              variant="empty"
              [icon]="timerPreviewMode === TIMER_STATES.LOW ? 'preview_eye' : 'preview_eye_crossed'"
              [iconColor]="
                timerPreviewMode === TIMER_STATES.LOW ? 'var(--on-surface-default)' : 'var(--on-surface-light)'
              "
              (click)="setTimerPreviewMode(TIMER_STATES.LOW)">
            </pdq-button>
          </div>
          <rich-text-editor
            [control]="timerForm.get('lowTimerMessage')"
            placeholder="Hurry - only {countdown} left!"
            [config]="{
              items: timerDynamicFieldsOptions$ | async,
              triggerChar: '{',
              filterByKey: 'searchTerm',
              removeTriggerCharOnSelect: true,
              descriptionKey: 'description',
              variant: 'categorizedOptions',
            }"></rich-text-editor>
          <p class="timer-info-text">
            Dynamic fields available. Type &#123; to see options.<br />Ex: Use &#123;countdown&#125; to dynamically
            display the time remaining
          </p>

          <div class="low-timer-labels-row">
            <span class="low-timer-threshold-label">Show when Remaining time is under:</span>
            <span class="low-timer-threshold-label">Low time style</span>
          </div>
          <div class="timer-duration-row">
            <pdq-input-arrows
              widthSize="fullwidth"
              min="1"
              max="60"
              formControlName="lowTimerThreshold"
              placeholder="5"></pdq-input-arrows>
            <pdq-dropdown
              (onChange)="onLowTimerThresholdUnitChange($event)"
              [options]="lowTimerThresholdUnitOptions"
              [dirty]="false"
              [defaultOption]="
                timerForm.get('lowTimerThresholdUnit')?.value | primitiveDropdownOptionPipe
              "></pdq-dropdown>
            <div class="low-timer-background-wrapper">
              <pdq-dropdown
                formControlName="lowTimerBackgroundColor"
                [options]="bannerVariantOptions"
                [fullWidth]="true"
                class="low-timer-background-dropdown"></pdq-dropdown>
            </div>
          </div>

          <div class="messages-subtitle-wrapper">
            <span class="messages-subtitle">Message When Time Has Expired</span>
            <pdq-button
              class="eye-preview-button"
              variant="empty"
              [icon]="timerPreviewMode === TIMER_STATES.EXPIRED ? 'preview_eye' : 'preview_eye_crossed'"
              [iconColor]="
                timerPreviewMode === TIMER_STATES.EXPIRED ? 'var(--on-surface-default)' : 'var(--on-surface-light)'
              "
              (click)="setTimerPreviewMode(TIMER_STATES.EXPIRED)">
            </pdq-button>
          </div>
          <rich-text-editor
            [control]="timerForm.get('expiredMessage')"
            placeholder="offer expired"
            [config]="{
              items: timerDynamicFieldsOptions$ | async,
              triggerChar: '{',
              filterByKey: 'searchTerm',
              removeTriggerCharOnSelect: true,
              descriptionKey: 'description',
              variant: 'categorizedOptions',
            }"></rich-text-editor>
          <p class="timer-info-text">
            Dynamic fields available. Type &#123; to see options.<br />Ex: Use &#123;countdown&#125; to dynamically
            display the time remaining
          </p>

          <div class="field-group">
            <pdq-dropdown
              formControlName="expiredBackgroundColor"
              [options]="bannerVariantOptions"
              [fullWidth]="true"
              [title]="'Expired time style'"></pdq-dropdown>
          </div>
        }

        <pdq-heading element="h6">Expiration Behavior</pdq-heading>
        <pdq-radio-group formControlName="expirationBehavior" label="">
          <pdq-radio-button
            [value]="EXPIRATION_BEHAVIORS.SHOW_EXPIRED_MESSAGE"
            text="Show Expired Message"
            [checked]="
              timerForm.get('expirationBehavior')?.value === EXPIRATION_BEHAVIORS.SHOW_EXPIRED_MESSAGE
            "></pdq-radio-button>
          <pdq-radio-button
            [value]="EXPIRATION_BEHAVIORS.HIDE_UPSELL"
            text="Hide Upsell"
            [checked]="
              timerForm.get('expirationBehavior')?.value === EXPIRATION_BEHAVIORS.HIDE_UPSELL
            "></pdq-radio-button>
        </pdq-radio-group>
      </div>
    </pdq-card>
  </div>
</div>
